import dayjs from "dayjs";

// convert meeting name and date to a title
export const getMeetingName = (meetingType: string, meetingDate?: string) =>
  `${dayjs(meetingDate).format("YYYY")} ${meetingType
    .charAt(0)
    .toUpperCase()}${meetingType.slice(1)} meeting`;
